import { createSlice } from "@reduxjs/toolkit";
import { getProfileThunk, loginThunk, removeProfilePictureThunk, updateProfileThunk } from "../thunks/authThunk";

const initialState = {
    user: null,
    token: null
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: () => initialState, // Reset state on logout
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginThunk.fulfilled, (state, action) => {
                state.user = action?.payload?.data?.user;
                state.token = action?.payload?.data?.token;
            })
            .addCase(getProfileThunk.fulfilled, (state, action) => {
                if (action?.payload?.data?.user) {
                    state.user = action.payload.data.user;
                }
            })
            .addCase(updateProfileThunk.fulfilled, (state, action) => {
                if (action?.payload?.data?.user) {
                    state.user = action.payload.data.user;
                }
            })
            .addCase(removeProfilePictureThunk.fulfilled, (state, action) => {
                if (action?.payload?.data?.user) {
                    state.user = action.payload.data.user;
                }
            })
    }
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
